<p-fluid>
    <div class="grid flex mb-5">
        <div class="col-6">
            <h1 class="mt-0 mb-0">Forecast Planning</h1>
        </div>
        <div class="col-2 flex align-items-center">
            <p-datepicker
                class="p-fluid"
                dateFormat="yy-mm"
                selectionMode="range"
                placeholder="Select a period"
                view="month"
                [readonlyInput]="true"
                [showButtonBar]="true"
                [(ngModel)]="selectedDateRange"
                (onSelect)="dateRangeChanged()"
                (onClearClick)="dateRangeCleared()"
                [maxDate]="maxSelectableDate"
            ></p-datepicker>
        </div>
        <div class="col-2 flex align-items-center">
            <p-select
                class="p-fluid"
                placeholder="Select a manufacturer"
                [showClear]="true"
                [options]="(manufacturers$ | async)?.getManufacturers()"
                [(ngModel)]="selectedManufacturer"
                optionLabel="name"
                (onChange)="manufacturerChanged()"
            ></p-select>
        </div>
        <div class="col-2 flex align-items-center">
            <p-button
                class="p-fluid"
                [disabled]="!canCreateForecast()"
                (click)="enterNewForecast()"
            ><icon icon="add" />Enter new Forecast</p-button>
        </div>
    </div>
</p-fluid>

<div class="grid">
    <div class="col-12">
        @if (months.length > 0) {
            <p-table [value]="uniquePlanningParameters" dataKey="id" [expandedRowKeys]="expandedRows">
                <ng-template #header>
                    <tr>
                        <th style="width: 3rem"></th>
                        <th>Planning Parameter</th>
                        @for (period of months; track period) {
                            <th class="text-center">{{ period }}</th>
                        }
                    </tr>
                </ng-template>
                <ng-template #body let-pp let-expanded="expanded">
                    <tr>
                        <td>
                            <p-button
                                [pRowToggler]="pp"
                                [text]="true"
                                [rounded]="true"
                                [plain]="true"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                            />
                        </td>
                        <td><strong>{{ pp.name }}</strong></td>
                        @for (monthDate of monthDates; track monthDate) {
                            <td class="text-center" #cm style="position: relative">
                                @if (findForecast(pp, monthDate); as forecast) {
                                    @if (forecast.status === 'unconfirmed') {
                                        {{ forecast.requestedQuantity }}
                                    } @else {
                                        <p-badge [value]="getForecastDisplayQuantity(forecast)" [severity]="getForecastStatusColor(forecast)" [pTooltip]="getForecastDisplayQuantity(forecast)" tooltipPosition="top" />
                                    }

                                    <span style="position: absolute; right: 0; top: 50%; transform: translateY(-50%)">
                                        <p-button icon="pi pi-ellipsis-v" size="small" [text]="true" (click)="selectForecast(forecast); cm.show($event)" />
                                        <p-contextMenu #cm [model]="forecastActions" appendTo="body" />
                                    </span>
                                }
                            </td>
                        }
                    </tr>
                </ng-template>
                <ng-template #expandedrow let-pp>
                    @for (subsidiary of getSubsidiariesForPP(pp); track subsidiary.id) {
                        <tr>
                            <td></td>
                            <td class="pl-4 pt-1 pb-1 text-color-secondary">{{ subsidiary.name }}</td>
                            @for (monthDate of monthDates; track monthDate) {
                                <td class="text-center pt-1 pb-1 text-color-secondary">
                                    @if (findForecastDetail(pp.id, subsidiary.id, monthDate); as detail) {
                                        {{ detail.requestedQuantity }}
                                    }
                                </td>
                            }
                        </tr>
                    }
                    <tr>
                        <td></td>
                        <td class="pl-4 pt-1 pb-1"></td>
                        @for (monthDate of monthDates; track monthDate) {
                            <td class="text-center pt-1 pb-1">
                                @if (findForecast(pp, monthDate); as forecast) {
                                    <icon
                                        icon="add"
                                        pTooltip="Add a forecast detail"
                                        tooltipPosition="top"
                                        (click)="addForecastDetail(forecast)"
                                    />
                                }
                            </td>
                        }
                    </tr>
                </ng-template>
            </p-table>
        } @else {
            <span>Select a date range and manufacturer to see the forecasts.</span>
        }
    </div>
</div>

@if (selectedManufacturer) {
    <app-enter-new-forecast
        [(visible)]="showEnterNewForecastModal"
        [manufacturer]="selectedManufacturer"
        (saved)="onNewForecastEntered($event)"
    />
}

<app-add-forecast-detail
    [(visible)]="showAddForecastDetailModal"
    [forecast]="selectedForecast"
    (saved)="onForecastDetailSaved()"
/>

<app-allocate-goods
    [(visible)]="showAllocateGoodsModal"
    [forecast]="selectedForecast"
    (saved)="onGoodsAllocated($event)"
/>

<app-revise-forecast-quantity
    [(visible)]="showReviseForecastModal"
    [forecast]="selectedForecast"
    (saved)="onForecastRevised()"
/>
